import { render, staticRenderFns } from "./MySlot.vue?vue&type=template&id=7561dafa&scoped=true&"
import script from "./MySlot.vue?vue&type=script&lang=js&"
export * from "./MySlot.vue?vue&type=script&lang=js&"
import style0 from "./MySlot.vue?vue&type=style&index=0&id=7561dafa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7561dafa",
  null
  
)

export default component.exports